import { formatDuration, intervalToDuration, parse } from 'date-fns';
import { condencedDateLocale } from "./condencedDateLocale";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ContractTerm = _ref => {
  let {
    contract,
    variant = 'default'
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: formatDuration(intervalToDuration({
      start: parse(contract.startDate, 'yyyy-MM-dd', new Date()),
      end: parse(contract.endDate, 'yyyy-MM-dd', new Date())
    }), {
      locale: variant === 'condenced' ? condencedDateLocale : undefined
    })
  });
};